import { useQuery } from '@tanstack/react-query';
import * as personaService from '../services/personaService';
import type { Persona } from '../types/persona';

export function usePersonas(options?: { enabled?: boolean }) {
  return useQuery<Persona[]>(['personas'], () => personaService.getPersonas(), {
    staleTime: 60_000,
    enabled: options?.enabled ?? true,
  });
}
